/** Phone: drawer sidebar, hamburger, fixed composer. */
export const PHONE_MAX_WIDTH = 699;

/** Tablet + phone: ChatInfo / MessageThread drawers, overlay panels. */
export const TABLET_MAX_WIDTH = 1024;

export function isPhoneViewport(width = window.innerWidth): boolean {
  return width <= PHONE_MAX_WIDTH;
}

export function isTabletViewport(width = window.innerWidth): boolean {
  return width > PHONE_MAX_WIDTH && width <= TABLET_MAX_WIDTH;
}

/** True when drawer-style panels (info, thread) should be used. */
export function isTabletOrBelowViewport(width = window.innerWidth): boolean {
  return width <= TABLET_MAX_WIDTH;
}
